import React from 'react';
// eslint-disable-next-line
import { Input, Table } from 'antd';
// eslint-disable-next-line
import { FilterOutlined } from '@ant-design/icons';

import { poStatusMap } from 'constants/enums';

type Props = {
  height?: number;
  onSelectPo?: Function;
  poList: StringKAnyVPair[];
};

const PoListView = (props: Props) => {
  const columns = [
    {
      title: 'PO#',
      dataIndex: 'poNumber',
    },
    /*{
      title: 'PO Warehouse',
      dataIndex: 'warehouseCode',
    },*/
    {
      title: 'Supplier',
      dataIndex: 'vendorName',
    },
    {
      title: 'PO Status',
      render(row: any) {
        //return poControlStatus[`${row.controlStatus}`] || '';
        return poStatusMap[row.poStatusNum] || '';
      },
    },
  ];

  const listRowProps = (row: StringKAnyVPair) => ({
    onClick: () => onRowClick(row),
    style: {
      backgroundColor: row.poStatusNum === 2 ? '#FFFBE6' : undefined,
    },
  });

  const onRowClick = (record: StringKAnyVPair) => {
    //console.log('re', record);
    if (props.onSelectPo) props.onSelectPo(record);
  };

  const tableScrollHeight = () => {
    if (props.height) {
      const h = props.height - 92 - 20;

      return h > 0 ? h : 0;
    }
  };

  return (<div>
    {/*<div style={{marginBottom: 12}}>
      <Input
        placeholder="Filter"
        prefix={<FilterOutlined />}
        size="large"
      />
    </div>*/}
    <Table
      columns={columns}
      dataSource={props.poList}
      onRow={listRowProps}
      pagination={false}
      rowKey="poNum"
      scroll={{y: tableScrollHeight()}}
      size="middle"
    />
  </div>);
};

export default PoListView;
